module.exports = __webpack_public_path__ + "img/avatar.aac66ff9.jpg";